import * as z from 'zod';

export const CONTACT_SUBJECT_OPTIONS = [
  'Tilmelding - B',
  'Tilmelding - BE',
  'Tilmelding - Generhvervelse',
  'Tilmelding - Særlig plan',
  'Køreprøve',
  'Spørgsmål/hjælp',
  'Andet',
] as const;

export const contactSchema = z.object({
  first_name: z.string({ error: 'Indtast dit fornavn' }).min(1, { error: 'Indtast dit fornavn' }),
  last_name: z.string({ error: 'Indtast dit efternavn' }).min(1, { error: 'Indtast dit efternavn' }),
  company: z.string().optional(),
  vat_number: z.string().optional(),
  phone_number: z.string().optional(),
  email: z.email({ error: 'Indtast en gyldig emailadresse' }),
  subject: z.enum(CONTACT_SUBJECT_OPTIONS, { error: 'Vælg et emne' }),
  message: z.string({ error: 'Skriv din besked' })
    .min(1, { error: 'Skriv din besked' })
    .max(5000, { error: 'Beskeden må højst være 5000 tegn' }),
});

export type ContactFormData = z.infer<typeof contactSchema>;
